import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { fetchAuthSession } from 'aws-amplify/auth';
import { catchError, from, switchMap } from 'rxjs';
import { getCookie } from 'typescript-cookie';

export const authInterceptor: HttpInterceptorFn = (request, next) => {

  const router = inject(Router);

  //console.log('intercepted request', request);

  return from(fetchAuthSession()).pipe(
    switchMap((auth: any) => {

      let token: string | undefined = auth?.tokens?.idToken?.toString() ; 

      if (!token) {
        token = getCookie('guest_token') ;
      }

      if (!token) {
        return next(request);
      }

      //console.log("jwt", token) ;
      const authRequest = request.clone({
        setHeaders: {
          Authorization: `Bearer ${token}`,
        },
      });
      
      return next(authRequest);
    }),
    catchError((err:any) => {

      if (err instanceof HttpErrorResponse) {
        if (err.status == 401) {
          router.navigate(['signin']);
        }
      }
      
      return next(request);
      //return throwError(() => new Error(err));
    })
  )
};
